import React, { useEffect } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import pic1 from "../../../assets/images/WhatsApp Image 2025-05-12 at 00.38.05_ae7f4905.jpg";
import { useNavigate } from "react-router-dom";
const MedicalExcellence = () => {
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="bg-gray-100 text-gray-800" style={{ marginTop: "80px" }}>
      <motion.header
        className="bg-blue-900 text-white py-16 text-center shadow-lg rounded-lg"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="bg-gradient-to-r from-blue-50 to-indigo-100 py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                <span className="text-white">
                  {" "}
                  🏥 Managing Medical Excellence,{" "}
                </span>
                <span className="text-blue-600"> 24/7</span>
              </h1>
              <p className="mt-4" style={{ fontWeight: "bold" }}>
                Welcome to Twenty Four Seven Consultancy
              </p>
              <p className="text-white mt-4">
                In the fast-paced world of healthcare, consistency, efficiency,
                and precision are non-negotiable. At Twenty Four Seven
                Consultancy, we specialize in providing round-the-clock
                management solutions tailored specifically for the medical
                industry. From patient payments to performance analytics, we
                help you focus on delivering top-tier care while we handle the
                rest.
              </p>
            </div>
          </div>
        </div>
      </motion.header>

      {/* Services Section */}
      <section className="py-16 bg-gray-100" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-blue-900 text-center">
          🔧 Our Comprehensive Healthcare Management Services
        </h2>
        <div
          className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-2 gap-8 px-8 mt-6"
          style={{ marginTop: "30px" }}
        >
          <motion.div
            className="p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              🧾 Patient Payments Management
            </h3>
            <p className="mt-2">
              Streamline your billing process with accurate invoicing, timely
              collections, and improved financial performance.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              📞 Patient Call Handling & Transcription
            </h3>
            <p className="mt-2">
              From managing appointment queries to transcribing consultation
              notes, we ensure every patient interaction is logged and
              accessible.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              🧮 Insurance Eligibility Verification
            </h3>
            <p className="mt-2">
              We verify patient coverage in real-time, minimizing claim denials
              and administrative delays.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              📊 Performance Reporting & Analytics
            </h3>
            <p className="mt-2">
              Get detailed insights with regular, customized reports that inform
              better operational and financial decisions.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Why Choose Us? */}
      <section className="py-16 bg-white" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-blue-900 text-center">
          🌟 Why Partner with Twenty Four Seven Consultancy?
        </h2>
        <div
          className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-8 px-8 mt-6"
          style={{ marginTop: "30px" }}
        >
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              ⏰ Always Available—24/7
            </h3>
            <p className="mt-2">
              Healthcare is non-stop, and so are we. Our team supports your
              operations around the clock—weekdays, weekends, and holidays.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              📋 End-to-End Management Expertise
            </h3>
            <p className="mt-2">
              From HR and compliance to financial oversight, we offer
              full-spectrum healthcare management under one roof.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              🏥 Healthcare-Focused Team
            </h3>
            <p className="mt-2">
              With deep industry knowledge, we stay aligned with medical
              regulations, insurance processes, and patient care standards.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              🎯 Tailored Strategies
            </h3>
            <p className="mt-2">
              No two healthcare organizations are alike. We craft personalized
              management strategies after understanding your goals, challenges,
              and organizational culture.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              🎯 Custom Strategies That Fit You
            </h3>
            <p className="mt-2">
              We tailor our services based on your organization’s size,
              structure, and specific challenges—no one-size-fits-all solutions.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-gray-100 rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              🤝 True Collaboration
            </h3>
            <p className="mt-2">
              We don’t just work for you—we work with you. Our transparent and
              proactive approach builds strong, long-term partnerships
            </p>
          </motion.div>
        </div>
      </section>
      <motion.section
        className="py-16 text-left bg-gray-100 shadow-md rounded-lg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <section
          id="practice-growth"
          className="py-20 bg-gray-50 px-6 md:px-20"
        >
          <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            {/* Left Content */}
            <div>
              <h2 className="text-3xl font-bold text-blue-900 mb-6">
                🌐 Ready to Take Your Practice to the Next Level?
              </h2>
              <p className="text-sm text-gray-700 mb-4">
                Partnering with Twenty Four Seven Consultancy means gaining a
                dedicated team that’s committed to your growth, your goals, and
                your patients.
              </p>
              <p className="text-sm text-gray-700 mb-4">
                Let us handle the operational complexity so you can focus on
                what matters most—exceptional patient care.
              </p>
              <p className="text-sm text-gray-700">
                📩 Contact us today to explore how we can elevate your
                healthcare management, 24 hours a day, 7 days a week.
              </p>
            </div>

            {/* Right Image */}
            <div className="flex justify-center">
              <img
                src={pic1}
                alt="Practice Growth"
                className="w-full max-w-md h-auto object-contain rounded-xl"
              />
            </div>
          </div>
        </section>
      </motion.section>

      {/* Final CTA */}
      <motion.section
        className="py-16 text-center bg-white shadow-md rounded-lg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <h2 className="text-3xl font-bold text-blue-900">
          ✅ READY TO START YOUR PROJECT?
        </h2>
        <button
          onClick={() => navigate("/bookmeeting")}
          className="mt-4 px-6 py-3 bg-blue-900 text-white font-bold rounded-lg shadow-lg hover:shadow-2xl hover:bg-blue-700 transition duration-300"
        >
          Let’s Start Together 🚀
        </button>
      </motion.section>
    </div>
  );
};

export default MedicalExcellence;
